<template>
  <div class="animated fadeIn quotes--quotes-list d-flex flex-column">
    <fixed-header title="Quotes" :records="pageInfo.totalItems" hideBackBtn>
      <add-quote v-if="checkClaim(CAN_ADD_QUOTES)" class="mr-2" />
    </fixed-header>
    <div class="card h-50">
      <div class="card-body d-flex flex-column">
        <grid-filters @filter="filteredListing" />
        <grid-component
          isResizable
          isReorderable
          isSortable
          :canEdit="checkClaim(CAN_EDIT_QUOTES)"
          :canDelete="checkClaim(CAN_DELETE_QUOTES)"
          :gridId="gridId"
          :pageable="pageable"
          :skip="pageInfo.pageSize * (pageInfo.pageNumber - 1)"
          :take="pageInfo.pageSize"
          :itemData="itemData"
          :pageSizes="pageInfo.pageSize"
          :totalItems="pageInfo.totalItems"
          :fields="fields"
          :sortBy="pageInfo.sortBy"
          :sortOrder="pageInfo.sortOrder"
          :sortMethod="sortGrid"
          :onEdit="pushToDetails"
          :onDelete="onDelete"
          :handleRowClick="onRowClick"
          :styleCustom="'height: 335px'"
          @getData="onGetData"
          :isTblLoader="tblLoader"
        />
      </div>
    </div>
    <div id="add-part-popup" class="d-inline pull-left">
      <b-modal id="add-part-popup" ref="add-part-popup" size="xl">
        <template slot="modal-header">
          <h5 class="modal-title">Edit Quote Detail</h5>
        </template>
        <line-details
          ref="editLineDetails"
          :lineObj="quoteLine"
          @partChange="onPartChange"
          @lineChange="onLineChange"
          @headerChange="onHeaderChange"
          @line-validation="isLineInvalid = $event"
        />
        <template slot="modal-footer">
          <b-button @click="handleCancel">Cancel</b-button>
          <b-button v-if="checkClaim(CAN_EDIT_QUOTES)" class="mr-2" variant="primary" @click="handleOk" :disabled="isSavingLine">
            <i v-if="isSavingLine" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Save</b-button>          
        </template>
      </b-modal>
    </div>

    <b-card>
      <b-tabs>
        <b-tab>
          <template v-slot:title>
            Quote Items &nbsp;<b-badge variant="primary">{{ quoteLines.length }}</b-badge>
          </template>
          <quote-lines :quoteId="selectedRowItemId" @showEdit="onShowEdit" hideDelete hideCheckBox />
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

import { dateTime, date } from '@/shared/filters';
import { GRID_PAGE_SIZES, GRID_ID } from '@/shared/constants';
import GridSettings from '@/shared/components/GridSettings';

import AddQuote from './components/AddQuote';
import QuoteLines from './components/QuoteLines';
import GridFilters from './components/GridFilters';

import FixedHeader from '@/shared/components/FixedHeader/indexNew';
import RequirementDetails from '@/shared/components/RequirementDetails/index';
import LineDetails from '@/shared/components/LineDetails/index';
import GridComponent from '@/shared/components/GridComponent';
import gridFields from './fields';

export default {
  components: {
    GridSettings,
    AddQuote,
    QuoteLines,
    GridFilters,
    FixedHeader,
    RequirementDetails,
    LineDetails,
    GridComponent
  },
  metaInfo: () => ({
    title: 'Quotes',
  }),
  data() {
    return {
      filtersVisible: false,
      fields: gridFields,
      gridId: GRID_ID.QUOTES,
      pageable: {
        pageSizes: GRID_PAGE_SIZES,
      },
      selectedRowItemId: 0,
      quoteLine: {},
      cloneQuoteLine: {},
      mergedObj: {},
      isLineInvalid: false,
      isSavingLine: false
    };
  },
  computed: {
    ...mapGetters('quotes', [
      'quotes',
      'pageInfo',
      'selectedQuoteId',
      'tblLoader',
      'lastOpenedQuoteId'
    ]),
    ...mapGetters('account', ['gridSettingsById']),
    ...mapGetters('quoteLines', ['quoteLinesById']),
    quoteLines() {
      return this.quoteLinesById(this.selectedRowItemId);
    },
    gridSettings() {
      return this.gridSettingsById(this.gridId);
    },
    itemData() {
      if (this.quotes == undefined || !this.quotes.length) return [];
      return this.quotes.map((quote) => ({ ...quote, selected: quote.id === this.selectedRowItemId }));
    },
  },
  filters: {
    dateTime,
    date,
  },
  methods: {
    ...mapActions('quotes', [
      'getAll',
      'sortGrid',
      'remove',
      'select',
      'deleteQuote',
      'clearFilters',
      'search'
    ]),
    ...mapActions('account', ['saveGridSettings']),
    // ...mapMutations('quotes', [
    //   'setLastOpenedQuoteId',
    //   'setQuotesState',
    // ]),

    ...mapMutations('quotes', [
      'setItem'
    ]),

    ...mapActions('quoteLines', [
      'updateQuoteLine',
      'getByQuoteId'
    ]),
    filteredListing() {
      this.selectedRowItemId = 0;
    },
    async onGetData(params) {
      await this.getAll(params);
    },
    onRowClick(row) {
      console.log('Current Selected Quote Row: ' + this.selectedRowItemId);
      if(this.selectedRowItemId != row.dataItem.id){
        this.selectedRowItemId = row.dataItem.id;
        console.log('Select Quote Row: ' + this.selectedRowItemId);
        const { id, detailsVisible } = row.dataItem;
        this.select({ id, isChecked: !detailsVisible });
      }
    },
    pushToDetails(row) {
      // this.setLastOpenedQuoteId(row.id);

      this.setItem({ resource: 'lastOpenedQuoteId', payload: row.id });

      this.$router.push({
        name: 'quotes.edit',
        params: { id: row.id },
      });
    },
    async onDelete({ id }) {
      const deleteConfirmed = await this.openConfirmBox({message: `Are you sure you want to delete quote?  This action cannot be undone`});
      if (deleteConfirmed) {
        await this.deleteQuote(id);
        this.getAll({});
      }
    },
    setQuoteline(quoteLine) {
      this.quoteLine = JSON.parse(JSON.stringify(quoteLine));

      console.log(quoteLine, this.quoteLine, this.quote);

      // this.quoteLine = { ...this.quoteLine };

      this.cloneQuoteLine = quoteLine;
      //this.marginPercent = this.profit / this.totalPrice * 100;
    },
    onShowEdit(quoteLine) {
      this.setQuoteline(quoteLine);
      this.$bvModal.show('add-part-modal');
    },
    onPartChange(partObj) {
        this.mergedObj = {
          ...this.mergedObj,
          alternativePN: partObj.altNumber,
          comment: partObj.comments,
          partId: partObj.id,
        };

        delete this.mergedObj.inventoryClassId;
      },
      onLineChange(lineObj) {
        this.mergedObj = {
          ...this.mergedObj,
          customerPN: lineObj.customerPN,
          quantity: lineObj.quantity,
          targetPrice: lineObj.price,
          price: lineObj.price,
          convertedPrice: lineObj.convertedPrice,
          dateCode: lineObj.dateCode,
          lotCode: lineObj.lotCode,
          revision: lineObj.revision,
          needsByDate: lineObj.needsByDate,
          testingRequested: lineObj.testingRequested,
          shippingMethodId: lineObj.shippingMethodId,
          conditionId: lineObj.conditionId,
          vendorNote: lineObj.vendorNote,
          comment: lineObj.comments,
        };
      },
      onHeaderChange(headerObj) {
        this.mergedObj = {
          ...this.mergedObj,
          currencyId: headerObj.currencyTypeId,
          exchangeRate: headerObj.exchangeRate,
        };
      },
      async handleOk(bvModalEvt) {
        await this.$refs.editLineDetails.getLineValidation();
        if (!this.isLineInvalid) {
          try {
            this.isSavingLine = true;
            const result = await this.updateQuoteLine({ ...this.quoteLine, ...this.mergedObj});
            console.log('update quoteline', result);
            this.isSavingLine = false;
          } catch {
          } finally {
            if(this.selectedRowItemId > 0){
              this.getByQuoteId(this.selectedRowItemId);
            }
            this.isSavingLine = false;
            this.$bvModal.hide('add-part-popup');
          }
        }
        //console.log('handleOk',bvModalEvt,this.quoteLine);

        // Prevent modal from closing
        //bvModalEvt.preventDefault()
        // Trigger submit handler
        //this.handleSubmit()
      },
      handleCancel() {
        this.quoteLine = { ...this.cloneQuoteLine };
        this.$bvModal.hide('add-part-popup');
      },
      // onQuoteListChanged({result}) {
      //   console.log(result, 'Quotes List')
      //   // this.setQuotesState(result);
      //
      //   this.setItem({ resource: 'quotes', payload: result });
      //
      // }
  },
  watch: {
    async quotes() {
      this.selectedRowItemId = await this.setSelectedRowId(this.quotes,this.selectedRowItemId,this.lastOpenedId);
      /*if(this.quotes.length > 0 && this.selectedRowItemId === 0 && !this.lastOpenedQuoteId) {
        this.selectedRowItemId = this.quotes[0].id;
        const { id, detailsVisible } = this.quotes[0];
        this.select({ id, isChecked: !detailsVisible });
      }*/
    },
  },
  mounted() {
    if('clear' in this.$route.query) {
      this.pageInfo.pageNumber=1;
      this.clearFilters();
      this.clearRoute();
    }else{
      if(this.lastOpenedQuoteId) {
        this.selectedRowItemId = this.lastOpenedQuoteId;
      }
      if('statisticFilter' in this.$route.params && this.$route.params.statisticFilter){
        delete this.$route.params.statisticFilter;
        // this.search(this.filters);
      }else {
        this.setItem({
          resource: 'pageInfo',
          payload: {...this.pageInfo, ...this.gridSettings.sort, ...this.gridSettings.pageSize}
        });
        this.getAll({});
      }
    }
  },
  created() {
    //this.$quoteHub.$on('quote-list-changed', this.onQuoteListChanged);
  },
  beforeDestroy() {
    this.select({ id: null, isChecked: false });
    //this.$quoteHub.$off('quote-list-changed', this.onQuoteListChanged);
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/_colors.scss';

.highlight {
  background: $rowSelection !important;
}

.quotes {
    &--quotes-list {
      .tools>* {
        margin: 0 0 0 3px;
      }

      .b-pagination {
        justify-content: center;
      }

      table td {
        cursor: pointer;
      }

      .buttons-panel {
        text-align: right;
        //margin-right: 30px;
        margin-top: 7px;

        .btn {
          margin-left: 5px;
        }

      }

      .clear-filter-button-container {
        margin-top: 12px;
        text-align: right;
      }
    }

    &--grid-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
</style>
